import { Wine, Grape } from "lucide-react";
import { WINE_RANGE, MENU_ITEMS } from "@/lib/menuData";

export default function BarMenu() {
  return (
    <section id="menu" data-testid="bar-menu-section" className="py-24 md:py-32 bg-white">
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <div className="text-center max-w-2xl mx-auto mb-16">
          <p className="text-sm uppercase tracking-[0.25em] font-semibold text-[#4A5D23]">At the Bar</p>
          <h2 className="mt-4 font-serif text-3xl md:text-4xl lg:text-5xl font-medium text-[#1C1917]">
            The Cellar Door Wine List
          </h2>
          <p className="mt-4 text-[#57534E] text-lg">
            Our full range across three estate labels. Tasting notes coming soon.
          </p>
        </div>

        {/* Wine range by label — stacked one column per label */}
        <div className="space-y-8 max-w-4xl mx-auto" data-testid="wine-range">
          {WINE_RANGE.map((group) => (
            <div
              key={group.label}
              data-testid={`wine-label-${group.label.toLowerCase().replace(/[^a-z0-9]+/g, "-")}`}
              className="rounded-2xl border border-[#E7E5E4] bg-[#FDFBF7] p-7 md:p-9"
            >
              <div className="flex items-center gap-2 pb-4 mb-5 border-b border-[#E7E5E4]">
                <Grape className="h-5 w-5 text-[#722F37]" />
                <h3 className="font-serif text-2xl text-[#1C1917]">{group.label}</h3>
              </div>
              <div className="grid grid-cols-2 sm:grid-cols-4 gap-6">
                {group.categories.map((cat) => (
                  <div key={cat.type}>
                    <p className="text-xs uppercase tracking-wider font-semibold text-[#4A5D23]">{cat.type}</p>
                    <ul className="mt-2 space-y-1.5">
                      {cat.wines.map((w) => (
                        <li key={w} className="text-[#1C1917] font-medium">{w}</li>
                      ))}
                    </ul>
                  </div>
                ))}
              </div>
            </div>
          ))}
        </div>

        {/* Grazing + image */}
        <div className="text-center max-w-2xl mx-auto mt-24 mb-16">
          <p className="text-sm uppercase tracking-[0.25em] font-semibold text-[#4A5D23]">On the Board</p>
          <h2 className="mt-4 font-serif text-3xl md:text-4xl lg:text-5xl font-medium text-[#1C1917]">
            The Cellar Door Menu
          </h2>
        </div>
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-16 items-center">
          <div className="rounded-2xl overflow-hidden shadow-sm border border-[#E7E5E4] order-2 lg:order-1">
            <img
              src="https://customer-assets.emergentagent.com/job_wine-tasting-book/artifacts/omxl8ys6_IMG_3860.webp"
              alt="Gledswood grazing spread with charcuterie, cheeses and dips"
              className="w-full h-72 lg:h-full object-cover"
            />
          </div>
          <div className="order-1 lg:order-2">
            <div className="flex items-center gap-2 mb-4">
              <Wine className="h-5 w-5 text-[#722F37]" />
              <h3 className="font-serif text-2xl text-[#1C1917]">Grazing</h3>
            </div>
            <p className="text-[#57534E] mb-6">
              Every tasting pairs beautifully with our grazing selection.
            </p>
            <ul className="space-y-3">
              {MENU_ITEMS.map((item) => (
                <li key={item.name} className="border-b border-dashed border-[#E7E5E4] pb-3">
                  {item.options ? (
                    <div>
                      <div className="flex justify-between gap-4">
                        <span className="font-medium text-[#1C1917]">{item.name}</span>
                        <span className="text-[#57534E] text-sm italic">{item.note}</span>
                      </div>
                      <div className="mt-1.5 flex flex-wrap gap-x-6 gap-y-1 text-sm text-[#57534E]">
                        {item.options.map(([label, price]) => (
                          <span key={label}>{label} <span className="text-[#1C1917] font-medium">{price}</span></span>
                        ))}
                      </div>
                    </div>
                  ) : (
                    <div className="flex justify-between gap-4">
                      <span className="font-medium text-[#1C1917]">{item.name}</span>
                      <span className="text-[#1C1917] font-medium text-sm text-right whitespace-nowrap">{item.price}</span>
                    </div>
                  )}
                </li>
              ))}
            </ul>
            <p className="mt-6 text-sm italic text-[#722F37]" data-testid="daily-specials-note">
              Check our daily specials for Chef's menu.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}
